"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var LayoutContext_1 = __importStar(require("./LayoutContext"));
var SkipNav_1 = __importDefault(require("./SkipNav"));
var RootLayout = function (_a) {
    var children = _a.children;
    var _b = __read(react_1.useState({}), 2), skipNavPairs = _b[0], setSkipNavPairs = _b[1];
    return (react_1.default.createElement(LayoutContext_1.RootLayoutContext.Provider, { value: {
            skipNavPairs: skipNavPairs,
            registerSkipNav: react_1.useCallback(function (key, skipNavable) {
                setSkipNavPairs(function (curr) {
                    var _a;
                    return (__assign(__assign({}, curr), (_a = {}, _a[key] = skipNavable, _a)));
                });
            }, []),
            unregisterSkipNav: react_1.useCallback(function (key) {
                setSkipNavPairs(function (curr) {
                    var result = __assign({}, curr);
                    delete result[key];
                    return result;
                });
            }, []),
        } }, children));
};
var LayoutContainer = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex-grow: 1;\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  transition: background-color 0.1s ease;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  flex-grow: 1;\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  transition: background-color 0.1s ease;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var direction = _a.direction;
    switch (direction) {
        case LayoutContext_1.LayoutDirections.Column:
            return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          flex-direction: column;\n          /* flex-basis: 0 won't work as expected */\n          width: 0;\n        "], ["\n          flex-direction: column;\n          /* flex-basis: 0 won't work as expected */\n          width: 0;\n        "])));
        case LayoutContext_1.LayoutDirections.Row:
        default:
            return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          flex-direction: row;\n          height: 0;\n        "], ["\n          flex-direction: row;\n          height: 0;\n        "])));
    }
}, function (_a) {
    var isRoot = _a.isRoot;
    return isRoot && styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: 100%;\n      height: 100vh;\n    "], ["\n      width: 100%;\n      height: 100vh;\n    "])));
}, function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.colors.plain);
});
var Layout = react_1.forwardRef(function Layout(_a, ref) {
    var as = _a.as, skipNavProp = _a.skipNav, directionProp = _a.direction, children = _a.children, props = __rest(_a, ["as", "skipNav", "direction", "children"]);
    var parentContext = LayoutContext_1.useLayoutContext();
    var isRoot = !parentContext;
    var skipNav = skipNavProp;
    var direction = directionProp;
    if (isRoot) {
        direction = fallback_1.default(direction, LayoutContext_1.LayoutDirections.Column);
        skipNav = fallback_1.default(skipNav, react_1.default.createElement(SkipNav_1.default, null));
    }
    else if (direction === undefined) {
        if (parentContext.direction === LayoutContext_1.LayoutDirections.Column)
            direction = LayoutContext_1.LayoutDirections.Row;
        else
            direction = LayoutContext_1.LayoutDirections.Column;
    }
    var content = (react_1.default.createElement(LayoutContext_1.default.Provider, { value: { direction: direction } },
        react_1.default.createElement(LayoutContainer, __assign({ as: as, ref: ref, direction: direction, isRoot: isRoot }, props),
            skipNav,
            children)));
    return parentContext ? content : react_1.default.createElement(RootLayout, null, content);
});
exports.default = Layout;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
